import type { SlideDefinition } from "../types";

export const SLIDE_DEFINITIONS = [
  {
    id: "program",
    label: "プログラム",
    description: "前夜祭の5つの演目を順番に案内します。",
  },
  {
    id: "kakuzuke",
    label: "企画紹介（格付けチェック）",
    description: "格付けチェック企画の専用ビジュアルを大きく表示します。",
  },
  {
    id: "twenty-doors",
    label: "企画紹介（10の扉）",
    description: "10の扉企画の専用ビジュアルを大きく表示します。",
  },
  {
    id: "ogiri",
    label: "企画紹介（大喜利）",
    description: "大喜利企画の専用ビジュアルを大きく表示します。",
  },
  {
    id: "love-advice",
    label: "企画紹介（朋優恋愛相談）",
    description: "朋優恋愛相談企画の専用ビジュアルを大きく表示します。",
  },
  {
    id: "participation",
    label: "参加状況",
    description: "ReMaSysの認証済み人数と参加率を表示します。",
  },
  {
    id: "countdown",
    label: "カウントダウン",
    description: "設定した開始時刻までの残り時間を表示します。",
  },
] as const satisfies readonly SlideDefinition[];

export const PROGRAM_ITEMS = [
  "オープニングムービー",
  "「朋優格付けチェック」",
  "10の扉",
  "大喜利",
  "「朋優恋愛相談」",
] as const;
